const BULLET = '•';

/** `maria@gmail.com` → `m•••a@gmail.com` */
export function maskEmail(email: string) {
  const at = email.lastIndexOf('@');
  if (at < 0) return email;

  const local = email.slice(0, at);
  if (local.length <= 2) return email;

  return `${local[0]}${BULLET.repeat(3)}${local[local.length - 1]}${email.slice(at)}`;
}

/** `+34612345678` → `+34 6•• ••• •78` */
export function maskPhone(phone: string, dialCode = '') {
  const rest =
    dialCode && phone.startsWith(dialCode) ? phone.slice(dialCode.length) : phone;
  const digits = rest.replace(/\D/g, '');
  if (digits.length <= 3) return phone;

  const masked = digits
    .split('')
    .map((digit, index) => (index === 0 || index >= digits.length - 2 ? digit : BULLET))
    .join('')
    .replace(/(.{3})(?=.)/g, '$1 ');

  return dialCode ? `${dialCode} ${masked}` : masked;
}
